<p-dialog [style]="{width: '70%'}" [breakpoints]="{ '1024px': '90%' }" [(visible)]="display" appendTo="body" (onHide)="hideDialog($event)" [modal]="true" [resizable]="false" [draggable]="false">
  <p-header>
      {{"客戶簽收單上傳: Booking " + bookingNo}}
  </p-header>
  <div class="mt-2">
    <h4>以 Booking 上傳</h4>
    <div class="container">
      <div class="formgrid grid">
          <div class="field col-12">
              <label>檔案</label>
              <p-fileUpload #fileUploadByBooking [customUpload]="true" (uploadHandler)="fileUploaderByBooking($event)" chooseLabel="選擇" uploadLabel="上傳" cancelLabel="取消"
                  [disabled]="isLoading" [showUploadButton]="!isLoading">
              </p-fileUpload>
          </div>
      </div>
    </div>
    <p-table [value]="podByBooking" class="datatable" [resizableColumns]="true" [reorderableColumns]="true" [rowHover]="true" [loading]="isLoading" columnResizeMode="expand" [paginator]="false" [autoLayout]="true" sortMode="multiple">
        <ng-template pTemplate="header">
            <tr>
                <th pResizableColumn pReorderableColumn>倉別</th>
                <th pResizableColumn pReorderableColumn>版本</th>
                <th pResizableColumn pReorderableColumn>上傳人</th>
                <th pResizableColumn pReorderableColumn>最後更新時間</th>
                <th pResizableColumn pReorderableColumn>下載</th>
                <th pResizableColumn pReorderableColumn>刪除</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr [pSelectableRow]="rowData">
                <td>{{rowData.facility}}</td>
                <td>{{rowData.version}}</td>
                <td>{{rowData.updateUser}}</td>
                <td>{{rowData.updateDt | date:'yyyy/MM/dd HH:mm:ss'}}</td>
                <td>
                    <i class="pi pi-cloud-download" (click)="downloadChange($event, rowData)"></i>
                </td>
                <td>
                    <i class="pi pi-trash" (click)="deleteFile($event, rowData)"></i>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="8" style="text-align: center;">
                    {{ 'Common.Table.NoData' | translate }}
                </td>
            </tr>
        </ng-template>
    </p-table>
  </div>

  <div class="mt-2">
      <h4>以 {{ 'DeliveryOrder.DoNo' | translate }} 上傳</h4>
      <div class="container">
        <div class="formgrid grid">
            <div class="field col-12">
                <label>檔案</label>
                <p-fileUpload #fileUploadByBookingDetail [customUpload]="true" (uploadHandler)="fileUploaderByBookingDetail($event)" chooseLabel="選擇" uploadLabel="上傳" cancelLabel="取消"
                    [disabled]="isLoading" [showUploadButton]="!isLoading">
                </p-fileUpload>
            </div>
        </div>
      </div>
      <p-table [value]="podByBookingDetail" class="datatable" [(selection)]="selectedBookingDetail" [columns]="columns" [resizableColumns]="true" [reorderableColumns]="true" [rowHover]="true" [loading]="isLoading" columnResizeMode="expand" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" [autoLayout]="true" sortMode="multiple">
          <ng-template pTemplate="header">
              <tr>
                  <th></th>
                  <th pResizableColumn pReorderableColumn>倉別</th>
                  <th pResizableColumn pReorderableColumn>{{ 'DeliveryOrder.DoNo' | translate }}</th>
                  <th pResizableColumn pReorderableColumn>版本</th>
                  <th pResizableColumn pReorderableColumn>上傳人</th>
                  <th pResizableColumn pReorderableColumn>最後更新時間</th>
                  <th pResizableColumn pReorderableColumn>下載</th>
                  <th pResizableColumn pReorderableColumn>刪除</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
              <tr [pSelectableRow]="rowData">
                  <td>
                      <p-tableRadioButton [value]="rowData"></p-tableRadioButton>
                  </td>
                  <td>{{rowData.facility}}</td>
                  <td>{{rowData.doNo}}</td>
                  <td>{{rowData.version}}</td>
                  <td>{{rowData.updateUser}}</td>
                  <td>{{rowData.updateDt | date:'yyyy/MM/dd HH:mm:ss'}}</td>
                  <td>
                      <i *ngIf="isShowIcon(rowData)" class="pi pi-cloud-download" (click)="downloadChange($event, rowData)"></i>
                  </td>
                  <td>
                      <i *ngIf="isShowIcon(rowData)" class="pi pi-trash" (click)="deleteFile($event, rowData)"></i>
                  </td>
              </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
              <tr>
                  <td [attr.colspan]="8" style="text-align: center;">
                      {{ 'Common.Table.NoData' | translate }}
                  </td>
              </tr>
          </ng-template>
      </p-table>
  </div>
</p-dialog>
